<template>
  <div class="vue-route-transition-wrapper" :style="{'background-color': bgColor}" >
    <div class="loading k-square-holder2" v-if="state == 'loading'">
        <div class="k-square4 k-square4a"></div>
        <div class="k-square4 k-square4b"></div>
        <div class="k-square4 k-square4c"></div>
        <div class="k-square4 k-square4d"></div>
    </div>
    <div class="loading" v-else-if="state == 'empty'">

    </div>
    <div class="loading" v-else-if="state == 'error'">

    </div>
    <template v-else-if="state == 'content'">
        <slot name="header"></slot>
        <div class="vue-route-transition-content" :class="{'scroll':closeScroll}" :id="cId" @scroll="handleScroll" @touchstart="touchstart" @touchmove="touchmove">
        <slot></slot>
        </div>
        <slot name="footer"></slot>
        <slot name="outside"></slot>
    </template>
  </div>
</template>
<script>
export default {
  name: 'vlayout',
  props: {
    id: String,
    state: {
        type: String
    },
    message: {
        type: String
    },
    playbottom:{
      type:Number,
      default:10
    },
    closePlay:{
      type:Boolean,
      default:true
    },
    closeScroll:{
      type:Boolean,
      default:true
    },
    //背景颜色
    bgColor: {
       type: String,
       default: "#f3f4fa"
    },
  },
  data () {
    return {
      cId: this.id || this.$route.path.replace(/\//g, '_') || '_null_',
      startX:0,
      startY:0
    }
  },
   methods: {
    //绑定滚动事件，父类使用方法：@scroll="xxxxxx"将可获得滚动事件回调
    handleScroll(event){
      if(this.closeScroll)
      {
        this.$emit('scroll', event);
      }
      
    },
    touchstart(event) {
     // event.preventDefault() //阻止默认事件（长按的时候出现复制）
 
      this.startX = event.changedTouches[0].pageX
      this.startY = event.changedTouches[0].pageY
    },
    touchmove(event) { // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
          //event.preventDefault()
          const moveEndX = event.changedTouches[0].pageX
          const moveEndY = event.changedTouches[0].pageY
          const x = moveEndX - this.startX
          const y = moveEndY - this.startY
         // 如果滑动距离太短
          if (Math.abs(x) < 2 && Math.abs(y) < 2) { // 	Math.abs() 获取数的绝对值。
           // console.log("未滑动")
            return
          }
          var angle = Math.atan2(y, x) * 180 / Math.PI; // Math.atan2() 获取从 x 轴到点 (x,y) 的角度;  Math.PI 圆周率
          if (angle >= -135 && angle <= -45) {
              this.$EventBus.$emit("playmoveEvent",false);//通知监听页面
             // console.log("向下")
          } else if (angle > 45 && angle < 135) {
              this.$EventBus.$emit("playmoveEvent",true);//通知监听页面
              //this.$EventBus.$emit("playEvent",{model:{activity:true}});//通知监听页面
              //console.log("向上")
          } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
             // console.log("向左")
          } else if (angle >= -45 && angle <= 45) {
             // console.log("向右")
          }

          
    }
  },
   mounted() {

     //this.$EventBus.$emit("playPageEvent",this.closePlay);//通知监听页面
    // this.$EventBus.$emit("playPageEvent",{model:{closePlay:this.closePlay,bottom:this.playbottom}});//通知监听页面
   
  }
}
</script>

<style scoped>
.vue-route-transition-wrapper{
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
  .vue-route-transition-wrapper .vue-route-transition-content{
    width: 100%;
    height: 100%;
    flex: 1;
     overflow-x: hidden;
    position: relative;
  }
  .vue-route-transition-wrapper .scroll{
    overflow-y: auto;
   
    -webkit-overflow-scrolling: touch;
  }
  .loading{ position:absolute;top: 50%; left: 50%; -webkit-transform: translate(-50%,-50%); transform: translate(-50%,-50%); width: 50px;  }
.k-square4 {
	display:inline-block;
	width:15px;
	height:15px;
	background:#000;
	opacity:1;
	animation:k-loadingR 2.0s infinite;
	opacity:0;
}
.k-square4b {
	animation-delay:.5s
}
.k-square4c {
	animation-delay:1.5s
}
.k-square4d {
	animation-delay:1s
}
@keyframes k-loadingR {
	0% {
	opacity:.5;
	background:#000
}
30% {
	opacity:.5;
	background:#666
}
60% {
	opacity:0
}
75% {
	opacity:0
}
100% {
	opacity:.5;
	background:#000
}
}@keyframes k-loadingS {
	40% {
	transform:translateX(0);
	opacity:.8
}
100% {
	transform:translateX(300px);
	opacity:0
}
}
</style>



// WEBPACK FOOTER //
// src/components/v-layout.vue